import { render, staticRenderFns } from "./Pandi.vue?vue&type=template&id=1e54587c&scoped=true&"
import script from "./Pandi.vue?vue&type=script&lang=js&"
export * from "./Pandi.vue?vue&type=script&lang=js&"
import style0 from "./Pandi.vue?vue&type=style&index=0&id=1e54587c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e54587c",
  null
  
)

export default component.exports